<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-07"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <!--  TODO: i18n  -->
        <label slot="title">設備種別</label>
        <!--  TODO: auth code  -->
        <!--  TODO: i18n  -->
        <sp-smart-button @click="clickCancel" slot="cancel">キャンセル</sp-smart-button>
        <narrow-down @click="clickDone" slot="create">登録</narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <loading-dialog :dialog-visible="loading" />
      <div class="panel">
        <div class="tag-info margin-bottom-5">
          <div class="head margin-bottom-3">
            <span class="title">設備種別</span>
          </div>
          <div>
            <el-form ref="categoryForm" :inline="true" :rules="categoryRules" :model="category">
              <el-form-item label="設備種別ID" prop="categoryExId">
                <p v-if="category.categoryId != null">{{category.categoryExId}}</p>
                <el-input v-else v-model="category.categoryExId" maxlength="10" :disabled="category.categoryId != null" />
              </el-form-item>
              <br>
              <el-form-item label="設備種別名" prop="categoryName">
                <el-input v-model="category.categoryName" maxlength="20"/>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="tag-list">
          <div class="head">
            <span class="title">タグ情報</span>
            <narrow-down class="btn" @click="clickTagAdd">タグを追加</narrow-down>
          </div>
          <el-form ref="tagFrom" :model="category">
            <el-table class="table-tag" :data="category.tags">
              <el-table-column prop="id" label="" v-slot="row">
                タグ{{row.$index + 1}}
              </el-table-column>
              <el-table-column prop="name" label="タグ" v-slot="slot">
                <el-form-item :prop="`tags.${slot.$index}.name`" :rules="tagRules.name">
                  <el-input class="tb-input" maxlength="100" v-model="slot.row.name" />
                </el-form-item>
              </el-table-column>
              <el-table-column prop="label" label="タグ名" v-slot="slot">
                <el-form-item :prop="`tags.${slot.$index}.label`" :rules="tagRules.label">
                  <el-input class="tb-input" maxlength="20" v-model="slot.row.label" />
                </el-form-item>
              </el-table-column>
              <el-table-column prop="unit" label="単位" v-slot="slot">
                <el-form-item :prop="`tags.${slot.$index}.unit`" :rules="tagRules.unit">
                  <el-input class="tb-input" maxlength="10" v-model="slot.row.unit" />
                </el-form-item>
              </el-table-column>
              <el-table-column v-slot="row">
                <div class="buttons">
                  <sp-smart-button class="btn btn-remove" @click="clickTagRemove(row.row.id, row.$index)">削除</sp-smart-button>
                </div>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import Menubar from "@/components/leftmenu/DashBoard";
import HeadTitle from "@/components/common/head/head";
import SpSmartButton from "@/components/common/sp-smart-button";
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import { nextId } from "@/views/visual-env/utils";
import api from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";

const MAX_TAG_COUNT = 26;

export default {
  name: "DeviceTypeEdit",
  components: {LoadingDialog, MainLayout, Menubar, HeadTitle, NarrowDown, SpSmartButton },
  data() {
    return {
      loading: false,
      category: {
        buildingId: '',
        categoryId: null,
        categoryExId: '',
        categoryName: '',
        tags: [
          {
            id: nextId(),
            name: '',
            label: '',
            unit: ''
          }
        ]
      },
      categoryRules: {
        categoryExId: [
          {
            required: true,
            message: "設備種別IDは必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            pattern: /^[A-Za-z0-9]+$/,
            trigger: ["blur", "change"],
            message: '設備種別IDは半角英数字でご入力ください。'
          },
          {
            max: 10,
            message: "設備種別IDは10文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ],
        categoryName: [
          {
            required: true,
            message: "設備種別名は必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 20,
            message: "設備種別名は20文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ]
      },
      tagRules: {
        name: [
          {
            required: true,
            message: "タグは必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 100,
            message: "タグは100文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ],
        label: [
          {
            required: true,
            message: "タグ名は必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 20,
            message: "タグ名は20文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ],
        unit: [
          {
            required: true,
            message: "単位は必須項目です。",
            trigger: ["blur", "change"]
          },
          {
            max: 10,
            message: "単位は10文字以下でご入力ください。",
            trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  created() {
    // TODO: what is bread path?
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/buildings/search",
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
        path: "",
        title: "設備種別",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  methods: {
    clickDone() {
      Promise.all([this.$refs.categoryForm.validate(), this.$refs.tagFrom.validate()])
        .then(() => {
          if (this.category.categoryId) {
            this.doneUpdate();
          } else {
            this.doneCreate();
          }
        })
    },

    clickCancel() {
      this.$router.push({ name: 'deviceCategoryList' });
    },

    clickTagAdd() {
      if (this.category.tags.length < MAX_TAG_COUNT) {
        this.category.tags.push({
          id: nextId(),
          name: '',
          label: '',
          unit: ''
        });
      }
    },

    clickTagRemove(typeId, index) {
      if (this.category.tags.length > 1) {
        this.category.tags.splice(index, 1);
      }
    },

    doneInit() {
      this.category.buildingId = this.$route.params?.buildingId;
      this.category.categoryId = this.$route.params?.categoryId;
      if (this.category.categoryId) {
        this.loading = true;
        api.deviceCategoryDetail(this.category.categoryId)
          .then(({data}) => {
            const { body } = data;
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return;
            }
            this.category.categoryId   = body.categoryId;
            this.category.categoryExId = body.categoryExId;
            this.category.categoryName = body.categoryName;
            this.category.tags = body.tagList.map(t => ({
              id   : t.tagId,
              name : t.tagCode,
              label: t.tagName,
              unit : t.tagUnit
            }));
          })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    doneUpdate() {
      this.loading = true;
      api.deviceCategoryUpdate(this.category.categoryId, {
        categoryName: this.category.categoryName,
        tagList: this.category.tags.map((tag) => ({
          tagId  :  tag.id,
          tagCode: tag.name,
          tagName: tag.label,
          tagUnit: tag.unit
        }))
      }).then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.$messageIotSuccess(this.$t("message.common.updateSuccess", { field: '設備種別' }));
        this.$router.push({ name: 'deviceCategoryList' });
      }).catch((error) => {
        errorCodeMsg(error, this)
      }).finally(() => {
        this.loading = false;
      });
    },

    doneCreate() {
      this.loading = true;
      api.deviceCategoryCreate({
        type: '07',
        buildingId: this.category.buildingId,
        categoryExId: this.category.categoryExId,
        categoryName: this.category.categoryName,
        tagList: this.category.tags.map(tag => ({
          tagCode: tag.name,
          tagName: tag.label,
          tagUnit: tag.unit
        }))
      }).then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.$messageIotSuccess(this.$t("message.common.createSuccess", { field: '設備種別' }));
        this.$router.push({ name: 'deviceCategoryList' });
      }).catch((error) => {
        errorCodeMsg(error, this)
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.doneInit();
  }
}
</script>

<style scoped>
.panel .tag-info .input-line {
  display: flex;
}

.panel .tag-info .input-line label {
  width: 120px;
  line-height: 40px;
}

.panel .head {
  margin-left: 0;
  height: 40px;
}
.panel .head .btn {
  float: right;
}
.panel .head .title {
  height: 100%;
  line-height: 40px;
  float: left;
  font-weight: bolder;
}

.panel .tag-list .buttons .btn {
  width: 56px;
  height: 32px;
  padding: initial;
}

.panel .tag-list .tb-input {
  display: inline-block;
  width: 100%;
}

.panel .tag-list .tb-input::v-deep .el-input__inner {
  width: 100% !important;
}

.table-tag::v-deep .el-form-item {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}
</style>
